import { z } from "zod";

// OTP validation constants
const VALID_OTP_LENGTH = 6;
const INVALID_OTP_MESSAGE = `Please enter a valid ${VALID_OTP_LENGTH} -digit code`;

/**
 * Schema for validating OTP input (6-8 digits)
 * Used for phone verification in both email and phone update flows
 */
export const otpFormSchema = z.object({
  otp: z.string().length(VALID_OTP_LENGTH, { message: INVALID_OTP_MESSAGE }),
});
